import { z } from 'zod';
/**
 * These schema define the shape of return data from the Availity API. The
 * structure is documented here:
 * https://developer.availity.com/partner/product/257664/api/223464#/Coverages_100/operation/%2Fcoverages%2F%7Bid%7D/get
 */
const DetailedCoveragePayerSchema = z.object({
    payerId: z.string(),
    name: z.string(),
    responsePayerId: z.string().optional(),
    responseName: z.string().optional(),
    thirdPartyAdministration: z.boolean().optional(),
    primary: z.boolean().optional(),
    secondary: z.boolean().optional(),
    tertiary: z.boolean().optional(),
    insuredLastName: z.string().optional(),
    insuredFirstName: z.string().optional(),
    insuredMiddleName: z.string().optional(),
    contactInformation: z.array(z.object({})).optional(),
});
const PrimaryCareProviderSchema = z.object({
    name: z.string(),
    category: z.string().optional(),
    categoryCode: z.string().optional(),
});
const DetailedPlanSchema = z.object({
    status: z.string(),
    statusCode: z.string(),
    groupNumber: z.string(),
    groupName: z.string().optional(),
    coverageSummaryAdditionalPayers: z.array(z.object({})).optional(),
    eligibilityStartDate: z.iso.datetime().optional(),
    eligibilityEndDate: z.iso.datetime().optional(),
    description: z.string().optional(),
    coverageStartDate: z.iso.datetime().optional(),
    coverageEndDate: z.iso.datetime().optional(),
    insuranceType: z.string().optional(),
    insuranceTypeCode: z.string().optional(),
    primaryCareProvider: PrimaryCareProviderSchema.optional(),
    identityCardNumber: z.string().optional(),
    benefits: z.array(z.object({})),
    payerNotes: z.array(z.object({})).optional(),
});
export const FlowRealTimeEligibilityResultSchema = z.object({
    links: z.object({}),
    patient: z.object({}),
    subscriber: z.object({}),
    payer: DetailedCoveragePayerSchema,
    plans: z.array(DetailedPlanSchema),
    supplementalInformation: z.object({}),
    reminders: z.object({}),
});
//# sourceMappingURL=resultSchema.js.map